import styled from "styled-components"

export const AnalysisWrapper = styled.div`
  padding: 30px 0;
`